import { Component, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PlanesProvider, ProyectQr, PdfCarpetaProyectQr } from '../../../providers/planes';
import { NgbModal, ModalDismissReasons, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { AuthProvider } from '../../../providers/auth';
import { User } from '../../../providers/user';

@Component({
    selector: 'app-proyecto',
    templateUrl: './proyecto.component.html',
    styleUrls: ['./proyecto.component.css']
})
export class ProyectoComponent implements OnInit {

    editProyect: boolean = false;
    idUser: string = '';
    oldNameProyectoQr = '';
    proyectoQr: ProyectQr = new ProyectQr();

    @ViewChild('contentModalCarpeta') contentModalCarpeta;
    modalCarpeta: NgbModalRef;
    showCarpetaModal: {
        index: number;
        name: string;
        pdfs: PdfCarpetaProyectQr[];
    } = null;

    noPermisos: boolean = false;

    showAlertDeleteFile: boolean = false;
    deleteFileTemporal: PdfCarpetaProyectQr = null;

    constructor(private navParams: ActivatedRoute, public modalService: NgbModal, private _planes: PlanesProvider, public toastr: ToastsManager, public vcr: ViewContainerRef, private _auth: AuthProvider, private _user: User) {
        this.toastr.setRootViewContainerRef(vcr);
        this.idUser = this.navParams.snapshot.paramMap.get('idu');
        if (this.idUser == this._auth.userLoggend.id) {
            this.editProyect = this._auth.userLoggend.proyectosEdit;
            this.findProyects(this.idUser, this.navParams.snapshot.paramMap.get('idp'));
        } else {
            this.noPermisos = true;

            /* console.log('usuario', this._auth.userLoggend);
            this._user.find(this.idUser).then(u => {
                this.editProyect = u.proyectosEdit;
                this.findProyects(this.idUser, this.navParams.snapshot.paramMap.get('idp'));
            }); */
        }
    }

    changeNameCarpeta() {
        console.log(this.showCarpetaModal);
        this._planes.updateCarpetaQr(this.idUser, this.proyectoQr.id, this.showCarpetaModal).then(_ => {
            if (this.showCarpetaModal.index > this.proyectoQr.carpetas.length - 1) {
                this.proyectoQr.carpetas.push(this.showCarpetaModal);
                this.toastr.success('Carpeta Añadida al proyecto.');
            } else {
                this.toastr.success('Nombre Carpeta Actualizada.');
            }
        });
    }

    /* changeNameProyect() {
        if (this.proyectoQr.name != '' && this.oldNameProyectoQr != this.proyectoQr.name) {
            this._planes.updateQrChild(this.idUser, this.proyectoQr.id, 'name', this.proyectoQr.name).then(_ => {
                this.oldNameProyectoQr = this.proyectoQr.name.slice(0);
                this.toastr.success('Nombre Proyecto Actualizado.');
            });
        } else {
            this.proyectoQr.name = this.oldNameProyectoQr;
        }
    } */

    changeNewFile(e) {
        if (e.target.files && e.target.files.length > 0) {
            let file = e.target.files[0];
            this._planes.uploadFile(file, this.idUser, this.proyectoQr.id, this.showCarpetaModal.index).then(pdf => {
                this.showCarpetaModal.pdfs.push(pdf);
                this._planes.updateCarpetaQr(this.idUser, this.proyectoQr.id, this.showCarpetaModal).then(_ => {
                    this.toastr.success('Archivo añadido correctamente.');
                });
            });
        }
    }

    confirmDeleteFile(pdf: PdfCarpetaProyectQr){
        this.deleteFileTemporal = pdf;
        this.showAlertDeleteFile = !this.showAlertDeleteFile;
    }

    deleteFile(){
        this._planes.removeFile(this.deleteFileTemporal, this.idUser, this.proyectoQr.id, this.showCarpetaModal.index).then(_ => {
            this.showCarpetaModal.pdfs = this.showCarpetaModal.pdfs.filter(pdf => pdf != this.deleteFileTemporal);
            this._planes.updateCarpetaQr(this.idUser, this.proyectoQr.id, this.showCarpetaModal);
            this.showAlertDeleteFile = !this.showAlertDeleteFile;
        });
    }

    findProyects(idUser, idProyect) {
        this._planes.findByUserQrs(idUser, idProyect).then(qrs => {
            this.proyectoQr = qrs[0];
            this.oldNameProyectoQr = this.proyectoQr.name.slice(0);
            if (this.proyectoQr.imageQr == '') {
                setTimeout(() => {
                    var img = document.getElementById('codeQr').getElementsByTagName('img')[0];
                    if (img) {
                        this.proyectoQr.imageQr = img.src;
                        this._planes.updateQrChild(this.idUser, this.proyectoQr.id, 'imageQr', this.proyectoQr.imageQr);
                    } else {
                        setTimeout(() => {
                            img = document.getElementById('codeQr').getElementsByTagName('img')[0];
                            if (img) {
                                this.proyectoQr.imageQr = img.src;
                                this._planes.updateQrChild(this.idUser, this.proyectoQr.id, 'imageQr', this.proyectoQr.imageQr);
                            }
                        }, 2000);
                    }
                }, 2000);
            }
        });
    }

    /* focusName() {
        if (this.proyectoQr.name == '' || this.oldNameProyectoQr != this.proyectoQr.name)
            this.proyectoQr.name = this.oldNameProyectoQr;
    } */

    ngOnInit() {

    }

    openCarpeta(carpeta, i: number) {
        console.log(carpeta);
        if (carpeta) {
            this.showCarpetaModal = carpeta;
            this.showCarpetaModal.index = i;
            this.showCarpetaModal.pdfs = carpeta.pdfs ? carpeta.pdfs : [];
        } else {
            this.showCarpetaModal = {
                index: this.proyectoQr.carpetas.length,
                name: 'Default ' + this.proyectoQr.carpetas.length,
                pdfs: []
            }
        }

        this.modalCarpeta = this.modalService.open(this.contentModalCarpeta, { windowClass: 'intra-modal-lg' });
    }

    openEditProyect(modal) {
        this.modalCarpeta = this.modalService.open(modal);
    }

    saveEditProyect(){
        console.log('saveEditProyect', this.proyectoQr);
        this._planes.updateQr(this.idUser, this.proyectoQr).then(_ => {
            this.toastr.success('Datos Proyecto Actualizado.');
            this.modalCarpeta.close();
        });
    }

}



// WEBPACK FOOTER //
// ./src/app/pages/dash/proyecto/proyecto.component.ts